import React, { FC } from 'react';
import { Heading } from '..';
import styles from './MenuTitle.scss';
import { IOuter } from './MenuTitle.types';

export const MenuTitle: FC<IOuter> = ({ text }) => (
  <Heading size="extraTiny" className={styles.menuTitle}>
    {text}
  </Heading>
);
